import * as React from 'react'
import type { SVGIllustrationProps } from '../BaseIllustration'
import { BaseIllustration } from '../BaseIllustration'

export const ParcelTapeIllustration = (props: SVGIllustrationProps) => (
  <BaseIllustration xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 240 160" {...props}>
    <path
      fill="url(#dhl__illustrations_parceltapeillustration_svg_a)"
      d="m123.814 138.066 9.227-1.653-16.534-8.214-9.093 1.627z"
      opacity={0.6}
    />
    <path
      fill="url(#dhl__illustrations_parceltapeillustration_svg_b)"
      d="m162.054 131.16 31.814-3.547-20.16-6.267-23.867 4.72z"
      opacity={0.6}
    />
    <path
      fill="url(#dhl__illustrations_parceltapeillustration_svg_c)"
      d="m74.854 127.213 23.84-4.72-40.453-20.107-23.867 4.72z"
      opacity={0.6}
    />
    <path fill="#634509" d="m98.694 58.6 71.093-12.747-40.453-20.107-71.093 12.747z" />
    <path fill="#C39000" d="M77.148 26.946 148.24 14.2l-18.907 11.547-71.093 12.747z" />
    <path
      fill="#996A0D"
      d="m158.161 59.026 11.626-13.173-40.453-20.107-11.653 13.147zM98.694 58.6l33.493.826L91.734 39.32l-33.493-.826z"
    />
    <path fill="#FDDE84" d="m98.694 58.6 71.093-12.747-16.4-15.84L82.294 42.76z" />
    <path fill="#C39000" d="M98.694 58.6v63.893l-40.453-20.107V38.493z" />
    <path fill="#FCCE09" d="M98.694 58.6v63.893l71.093-12.747V45.853z" />
    <path
      fill="#9E7549"
      d="M201.681 103.159a20.566 20.566 0 0 1-18.16 19.974 16 16 0 0 1-18.427-16 20.56 20.56 0 0 1 18.16-19.973 16 16 0 0 1 17.024 9.26 16 16 0 0 1 1.403 6.739"
    />
    <path fill="#6B4C22" d="m183.574 126.253-10.267-5.04 8.454-.347z" />
    <path fill="#9E7549" d="m192.507 88.653 9.787 4.8-7.067 2.16z" />
    <path
      fill="#BC9361"
      d="M211.067 107.879a20.56 20.56 0 0 1-18.293 19.867 16 16 0 0 1-18.32-16 20.56 20.56 0 0 1 18.293-19.867 16 16 0 0 1 16.923 9.29 16 16 0 0 1 1.397 6.71"
    />
    <path
      fill="#E5E5E5"
      d="M206.827 108.333a15.78 15.78 0 0 1-14.053 15.253 12.35 12.35 0 0 1-12.98-7.191 12.36 12.36 0 0 1-1.073-5.155 15.79 15.79 0 0 1 14.053-15.254 12.34 12.34 0 0 1 9.856 2.953 12.35 12.35 0 0 1 4.197 9.394"
    />
    <path
      fill="#C9C9C9"
      d="M182.614 101.239a15.82 15.82 0 0 1 10.107-5.333 12.345 12.345 0 0 1 14.053 12.347 14.3 14.3 0 0 1-.773 4.64"
    />
    <path
      fill="#fff"
      d="M194.668 105.133a9.04 9.04 0 0 0-5.334-8.32 16.2 16.2 0 0 0-7.2 5.147 14.94 14.94 0 0 0-3.36 9.28 12.8 12.8 0 0 0 .88 4.8 10 10 0 0 0 4.587.586 11.81 11.81 0 0 0 10.427-11.493"
    />
    <path fill="#9E7549" d="m133.041 136.413 37.493-6.773-15.44-8.347-38.587 6.907z" />
    <path
      fill="#9E7549"
      d="M177.281 121.053a8.22 8.22 0 0 1-3.76 7.44c-.961.509-1.983.894-3.04 1.146l-15.387-8.266 3.52-.72a7.52 7.52 0 0 0 6.64-3.627 9.4 9.4 0 0 0 .4-5.333z"
    />
    <path fill="#EFEFEF" d="m67.894 141.773 30-5.387-29.733-14.693-30.027 5.386z" />
    <path
      fill="#000"
      fillRule="evenodd"
      d="m62.32 133.693 4.747 2.293 15.547-2.453-4.746-2.293zM49.28 127.399l4 1.974 15.548-2.454-4.027-1.946zM57.734 131.48l1.974.96 15.52-2.454-1.947-.933zM86.774 135.559l-2-.853-15.546 2.453 2.026.96zM55.44 130.386l.8.4 15.547-2.453-.8-.4z"
      clipRule="evenodd"
    />
    <defs>
      <linearGradient
        id="dhl__illustrations_parceltapeillustration_svg_a"
        x1={118.907}
        x2={121.547}
        y1={135.693}
        y2={130.546}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A1860E" stopOpacity={0} />
        <stop offset={0.21} stopColor="#fff" stopOpacity={0} />
        <stop offset={1} />
      </linearGradient>
      <linearGradient
        id="dhl__illustrations_parceltapeillustration_svg_b"
        x1={167.346}
        x2={169.014}
        y1={127.797}
        y2={121.63}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.25} stopOpacity={0} />
        <stop offset={0.599} stopOpacity={0.3} />
        <stop offset={1} stopOpacity={0.8} />
      </linearGradient>
      <linearGradient
        id="dhl__illustrations_parceltapeillustration_svg_c"
        x1={59.947}
        x2={66.38}
        y1={118.706}
        y2={104.975}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.25} stopOpacity={0} />
        <stop offset={0.599} stopOpacity={0.3} />
        <stop offset={1} stopOpacity={0.8} />
      </linearGradient>
    </defs>
  </BaseIllustration>
)
